import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { GlobalService } from "src/app/services/global.service";
import { UserService } from "src/app/services/user.service";

@Component({
    selector: "sd-subsription-popup",
    templateUrl: "./subsription-popup.component.html",
    styleUrls: ["./subsription-popup.component.scss"],
})
export class SubsriptionPopupComponent implements OnInit {
    selected: Boolean = true;
    constructor(
        public user: UserService,
        public router: Router,
        public route: ActivatedRoute,
        public global: GlobalService,
        public dialogRef: MatDialogRef<SubsriptionPopupComponent>
    ) { }



    ngOnInit(): void {
        // console.log(this.router.url)
        this.global.trackEvent('subscription', 'click', 'suscription-popup-open')
    }

    closeDialog() {
        this.dialogRef.close("");
        this.global.trackEvent('subscription', 'click', 'suscription-popup-close')

    }

    choosePlan(plan) {
        if (plan == 'pro') {
            this.selected = true;
            this.global.trackEvent('subscription', 'click', 'suscription-popup-pro')

        } else {
            this.selected = false;
            this.global.trackEvent('subscription', 'click', 'suscription-popup-basic')

        }
    }


}
